module.exports = __webpack_public_path__ + "img/T6-D-xh_15.c036d229.png";